<template>
  <div>
    <el-form :model="searchItem" inline size="small">
      <el-form-item label="ID">
        <el-input v-model.trim="searchItem.id" clearable @keyup.enter.native="search()"></el-input>
      </el-form-item>
      <el-form-item label="应用名称">
        <el-input v-model.trim="searchItem.name" clearable @keyup.enter.native="search()"></el-input>
      </el-form-item>
      <el-form-item label="应用编码">
        <el-input v-model.trim="searchItem.code" clearable @keyup.enter.native="search()"></el-input>
      </el-form-item>
      <el-form-item label="使用平台">
        <el-select v-model="searchItem.apply" clearable>
          <el-option v-for="item in appApply" :key="item.id" :label="item.msg" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="searchItem.status" clearable>
          <el-option v-for="item in commonStatus" :key="item.id" :label="item.msg" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="用户平台展示">
        <el-select v-model="searchItem.display" clearable>
          <el-option v-for="item in releaseDisplay" :key="item.id" :label="item.msg" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="需要安装">
        <el-select v-model="searchItem.need_install" clearable>
          <el-option v-for="item in releaseDisplay" :key="item.id" :label="item.msg" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="可选数量">
        <el-select v-model="searchItem.with_qty" clearable>
          <el-option v-for="item in releaseDisplay" :key="item.id" :label="item.msg" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="search">查询</el-button>
        <el-button type="primary" @click="reset" plain>重置</el-button>
      </el-form-item>
    </el-form>
    <vue-table :table-data="tableData" :count-list="countList">
      <template slot="icon" slot-scope="{row}">
        <el-image :src="row.icon" style="vertical-align: middle;height: 22px;line-height: 1" :preview-src-list="[row.icon]">
          <div slot="error" style="text-align: center;font-size: 20px">
            <i class="el-icon-picture-outline"></i>
          </div>
        </el-image>
      </template>
      <template slot="space" slot-scope="{row}">
        <span>{{translationFlowK(row.space)}}</span>
      </template>
      <template slot="price" slot-scope="{row}">
        <span>{{row.quantity}}个/</span>
        <span>{{row.duration}}{{appPeriodObj[row.period]}}/</span>
        <span>{{convertYuan(row.price)}}</span>
      </template>
      <template slot="quantity" slot-scope="{row}">
        <span v-if="row.with_qty">{{row.quantity}}</span>
        <span v-else>-</span>
      </template>
      <template slot="discount_rate" slot-scope="{row}">
        <span v-if="row.discount_rate">{{(row.discount_rate / 100).toFixed(2)}}</span>
        <span v-else>-</span>
      </template>
      <template slot="discount_time" slot-scope="{row}">
        <span v-html="formatTime(row.discount_time)"></span>
      </template>
      <template slot="free_time" slot-scope="{row}">
        <span v-html="formatTime(row.free_time)"></span>
      </template>
    </vue-table>
    <vue-pagination :paging-data="pagingData" @getData="getData" ref="paging"/>
  </div>
</template>

<script>
import {PagingData} from "@mixins"
import {commonStatus, releaseDisplay, appApply, appPeriod} from "@utils/formatList"
export default {
  name: "index",
  mixins: [PagingData],
  data() {
    return {
      appApply,
      releaseDisplay,
      commonStatus,
      searchItem: {
        id: "",
        name: "",
        code: "",
        apply: "",
        status: "",
        display: "",
        need_install: "",
        with_qty: "",
      },
      commitItem: null,
      appPeriodObj: this.formatToObj(appPeriod),
      countList: [
        {name: "总记录", count: 0},
      ],
      tableData: {
        tableList: [],
        tableColumn: [
          {label: "ID", property: "id", width: 70},
          {label: "应用图标", property: "icon"},
          {label: "应用名称", property: "name", tooltip: true, minWidth: 150},
          {label: "使用平台", property: "apply", format: appApply},
          {label: "应用简介", property: "describe", tooltip: true, minWidth: 150},
          {label: "占用空间", property: "space"},
          {label: "可选数量", property: "with_qty", format: releaseDisplay},
          {label: "应用单价(元)", property: "price", width: 130},
          {label: "应用版本", property: "version"},
          {label: "购买次数", property: "count", sort: "custom"},
          {label: "需要安装", property: "need_install", format: releaseDisplay},
          {label: "最小支持设备版本", property: "min_version"},
        ],
      },
    }
  },
  methods: {
    formatTime(time) {
      if (!time) return "-";
      const arr = time.split(",") || [];
      return `<p>开始：${arr[0]}</p><p>结束：${arr[1]}</p>`
    },
    search() {
      this.commitItem = {...this.searchItem};
      this.pagingData.currentPage = 1;
      this.getData();
    },
    reset() {
      Object.keys(this.searchItem).forEach(key => this.searchItem[key] = "");
      this.search();
    },
    async getData() {
      let nv = {
        page: this.pagingData.currentPage,
        limit: this.pagingData.pageSize,
      };
      this.copyObjValue(nv, this.commitItem);
      const res = await this.$Http.getAppList(nv);
      if (res?.data) {
        let total = +res.data.total || 0;
        this.pagingData.total = total;
        this.countList[0].count = total;
        this.tableData.tableList = res.data.list || [];
      }
    },
  },
  mounted() {
    this.getData();
  }
}
</script>

<style scoped lang="scss">

</style>
